import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGeoMenuIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 20,
	viewBox: "0 0 16 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.16667 19.5902C1.08333 11.3951 0 10.5366 0 7.49268C0 3.3561 3.54167 0 8 0C12.4167 0 16 3.3561 16 7.49268C16 10.5366 14.875 11.3951 8.79167 19.5902C8.41667 20.1366 7.54167 20.1366 7.16667 19.5902ZM8 10.6146C9.83333 10.6146 11.3333 9.24878 11.3333 7.49268C11.3333 5.77561 9.83333 4.37073 8 4.37073C6.125 4.37073 4.66667 5.77561 4.66667 7.49268C4.66667 9.24878 6.125 10.6146 8 10.6146Z",
		fill: "#AAAAAA"
	})
});
export default SvgGeoMenuIcon;
